import i18n from "i18next";
import { initReactI18next } from "react-i18next"; // https://react.i18next.com/latest/using-with-hooks
import Backend from "i18next-http-backend"; // For lazy loading for translations: https://github.com/i18next/i18next-http-backend
import detector from "i18next-browser-languagedetector"; // For auto detecting the user language: https://github.com/i18next/i18next-browser-languageDetector

i18n
    .use(Backend)
    .use(detector)
    .use(initReactI18next)
    .init({
        supportedLngs: ["fr", "en"],
        backend: {
            loadPath: "/locales/{{lng}}/{{ns}}.json", // locale files path
        },
        ns: ["common"],
        defaultNS: "common",
        fallbackLng: ["fr", "en"],
        lng: 'fr',
        interpolation: {
            // React already escapes everything it renders, so i18next's own escaping is
            // redundant and actively wrong for interpolated values: it turned the "/" in
            // a formatted date into "&#x2F;", which then rendered literally.
            escapeValue: false,
        },
    });

export default i18n;